"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeView = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lab = require("@material-ui/lab");
var _ExpandMoreRounded = _interopRequireDefault(require("@material-ui/icons/ExpandMoreRounded"));
var _ChevronRightRounded = _interopRequireDefault(require("@material-ui/icons/ChevronRightRounded"));
var _styles = require("./styles");
var _StyledTreeItem = require("./StyledTreeItem");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TreeView = _ref => {
  let {
    data,
    defaultCollapseIcon,
    defaultExpandIcon,
    color,
    onLabelClick,
    fullWidth,
    classes,
    treeItemClasses,
    parentWithClick
  } = _ref;
  const defaultClasses = (0, _styles.useStyles)({
    color,
    fullWidth
  });
  const customClasses = classes ? classes() : null;
  const customTreeItemClasses = treeItemClasses ? treeItemClasses() : null;
  const handleClick = (_event, node) => {
    if (Array.isArray(node.children)) {
      if (parentWithClick) {
        onLabelClick(_event, node);
      }
    } else {
      onLabelClick(_event, node);
    }
  };
  const renderNode = node => /*#__PURE__*/_react.default.createElement(_StyledTreeItem.StyledTreeItem, {
    key: node.id,
    nodeId: node.id,
    label: node.name,
    color: color,
    onClick: event => handleClick(event, node),
    classes: customTreeItemClasses
  }, Array.isArray(node.children) ? node.children.map(child => renderNode(child)) : null);
  return /*#__PURE__*/_react.default.createElement(_lab.TreeView, {
    defaultCollapseIcon: defaultCollapseIcon,
    defaultExpandIcon: defaultExpandIcon,
    className: defaultClasses.root,
    classes: customClasses
  }, data.map(treeViewItem => renderNode(treeViewItem)));
};
exports.TreeView = TreeView;
TreeView.propTypes = {
  /**
   * Icone do botão usado para colapsar um item
   */
  defaultCollapseIcon: _propTypes.default.node,
  /**
   * Icone do botão usado para expandir um item
   */
  defaultExpandIcon: _propTypes.default.node,
  /**
   * Cor de destaque do componente
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * Objeto com os dados da TreeView
   */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string
  }).isRequired).isRequired,
  /**
   * Função de click de um item com conteúdo
   */
  onLabelClick: _propTypes.default.func,
  /**
   * Faz com que o componente ocupe a largura total do container
   */
  fullWidth: _propTypes.default.bool,
  /**
   * Faz com que o componente possua click tanto no parent quanto no children
   */
  parentWithClick: _propTypes.default.bool,
  /**
   * Classes para customizar estilos do TreeView
   */
  classes: _propTypes.default.func,
  /**
   * Classes para customizar estilos dos items do TreeView
   */
  treeItemClasses: _propTypes.default.func
};
TreeView.defaultProps = {
  defaultCollapseIcon: /*#__PURE__*/_react.default.createElement(_ExpandMoreRounded.default, null),
  defaultExpandIcon: /*#__PURE__*/_react.default.createElement(_ChevronRightRounded.default, null),
  color: 'primary',
  onLabelClick: null,
  fullWidth: false,
  classes: null,
  treeItemClasses: null,
  parentWithClick: false
};